var React = require('react');

function Runs (props) {
    return React.createElement("svg",props,React.createElement("g",null,[React.createElement("line",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","x1":"1.6","y1":"2.2","x2":"12.2","y2":"2.2","key":0}),React.createElement("line",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","x1":"1.6","y1":"8","x2":"7.6","y2":"8","key":1}),React.createElement("line",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","x1":"1.6","y1":"13.8","x2":"5.1","y2":"13.8","key":2}),React.createElement("polygon",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","points":"\n\t\t9,5.5 10.3,8.1 9.1,10.9 14.4,8.1 \t","key":3})]));
}

Runs.displayName = "Runs";

Runs.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 16 16","enableBackground":"new 0 0 16 16","xmlSpace":"preserve"};

module.exports = Runs;

Runs.default = Runs;



//////////////////
// WEBPACK FOOTER
// ../icon/src/icons/runs.svg
// module id = ../icon/src/icons/runs.svg
// module chunks = 0